import React from 'react';
import Typography from '@mui/material/Typography';

const PURPLE = '#5124a6';

export function SectionTag({ children, sx: sxProp }) {
    return (
        <Typography
            sx={{
                display: 'inline-block',
                fontSize: '0.72rem',
                fontWeight: 700,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: PURPLE,
                mb: 1,
                ...sxProp,
            }}
        >
            {children}
        </Typography>
    );
}
